import { matches as v, isVisible as A, isFrame as x, getActiveElement as r, contains as T } from "./dom.js";
const u = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function E(t) {
  return parseInt(t.getAttribute("tabindex") || "0", 10) < 0;
}
function b(t) {
  return v(t, u) && A(t);
}
function c(t) {
  return b(t) && !E(t);
}
function f(t, e) {
  const n = Array.from(t.querySelectorAll(u));
  e && n.unshift(t);
  const o = n.filter(b);
  return o.forEach((a, s) => {
    if (x(a) && a.contentDocument) {
      const i = a.contentDocument.body;
      o.splice(s, 1, ...f(i));
    }
  }), o;
}
function d(t, e, n) {
  const o = Array.from(t.querySelectorAll(u)), a = o.filter(c);
  return e && c(t) && a.unshift(t), a.forEach((s, i) => {
    if (x(s) && s.contentDocument) {
      const l = s.contentDocument.body, F = d(l, !1, n);
      a.splice(i, 1, ...F);
    }
  }), !a.length && n ? o : a;
}
function p(t, e, n) {
  const [o] = d(t, e, n);
  return o || null;
}
function h(t, e, n, o) {
  const a = r(t), s = f(t, e), i = s.indexOf(a);
  return s.slice(i + 1).find(c) || null || null || null;
}
function k(t, e) {
  return h(document.body, !1);
}
function m(t, e, n, o) {
  const a = r(t), s = f(t, e).reverse(), i = s.indexOf(a);
  return s.slice(i + 1).find(c) || null || null || null;
}
function D(t, e) {
  return m(document.body, !1);
}
function S(t) {
  const e = r(t);
  if (!e) return !1;
  if (e === t) return !0;
  const n = e.getAttribute("aria-activedescendant");
  return n ? n === t.id : !1;
}
function g(t) {
  const e = r(t);
  if (!e) return !1;
  if (T(t, e)) return !0;
  const n = e.getAttribute("aria-activedescendant");
  return !n || !("id" in t) ? !1 : n === t.id ? !0 : !!t.querySelector(`#${CSS.escape(n)}`);
}
function q(t) {
  !g(t) && b(t) && t.focus();
}
function I(t) {
  const e = t.getAttribute("tabindex") ?? "";
  t.setAttribute("data-tabindex", e), t.setAttribute("tabindex", "-1");
}
function N(t, e) {
  d(t, e).forEach(I);
}
function B(t) {
  const e = t.querySelectorAll("[data-tabindex]"), n = (o) => {
    const a = o.getAttribute("data-tabindex");
    o.removeAttribute("data-tabindex"), a ? o.setAttribute("tabindex", a) : o.removeAttribute("tabindex");
  };
  t.hasAttribute("data-tabindex") && n(t), e.forEach(n);
}
export {
  I as disableFocus,
  N as disableFocusIn,
  q as focusIfNeeded,
  f as getAllFocusableIn,
  d as getAllTabbableIn,
  p as getFirstTabbableIn,
  k as getNextTabbable,
  h as getNextTabbableIn,
  D as getPreviousTabbable,
  m as getPreviousTabbableIn,
  S as hasFocus,
  g as hasFocusWithin,
  b as isFocusable,
  c as isTabbable,
  B as restoreFocusIn
};
//# sourceMappingURL=focus.js.map
